import generateReport from "../../services/AxiosReportService"
import api from "../../services/AxiosService";

export const generateDepositReport = (data) => {
    return generateReport("post", "api/account/deposit/generate", "", data);
};

export const getAllDeposits = () => {
    return api("get", "api/transaction/index", "", null);
};

export const generateDepositSummaryReport = (data) => {
    return generateReport("post", "api/account/monthly/generate", "", data);
};

export const generateDepositCustomerCountReport = (data) => {
    return generateReport("post", "api/account/deposit-customer-count/generate", "", data);
};


export const generateDepositsummaryBranchReport = (data) => {
    return generateReport("post", "api/account/branch/generate", "", data);
};

export const generateDormantDepositSummaryReport = (data) => {
    return generateReport("post", "api/account/dormant-account/generate", "", data);
};
export const generateDormantDepositsCumulativeByBranchReport = (data) => {
    return generateReport("post", "api/account/dormant-account-branch/generate", "", data);
};


export const generateDormantDepositsCumulativeReport = (data) => {
    return generateReport("post", "report/district/dormant-active-summary", "", data);
};
export const generateDormantDepositsCumulativeBranchReport = (data) => {
    return generateReport("post", "api/account/dormant-deposits-branch/generate", "", data);
};

export const generateSamurdhiBankDepositSummaryReport = (data) => {
    return api("post", "api/account/account-summary/generate", "", data);
};


export const generateSamurdhiBankOtherDepositSummaryReport = (data) => {
    return generateReport("post", "api/account/other-account-summary/generate", "", data);
};

export const generateSamurdhiBankProductWiseReport = (data) => {
    return generateReport("post", "api/account/product-wise/generate", "", data);
};

export const generateSamurdhiBankShareAccountReport = (data) => {
    return generateReport("post", "api/account/share-account/generate", "", data);
};

export const generateSamurdhiBankShareAccountReportDistrictWise = (data) => {
    return generateReport("post", "api/account/share-account-district-wise/generate", "", data);
};

export const generateSamurdhiBankOtherDepositsDistrictWise = (data) => {
    return generateReport("post", "api/account/dormant-other-deposits/generate", "", data);
};

export const generateSamurdhiBankShareDormantDistrictWise = (data) => {
    return generateReport("post", "api/account/dormant-account-district-wise/generate", "", data);
};

export const generateSamurdhiBankOtherAccountDistrictWise = (data) => {
    return generateReport("post", "api/account/other-account-district-wise/generate", "", data);
};

export const generateWasamReports = (data) => {
    return generateReport("post", "api/customer/wasam-wise-reports", "", data);
};

export const getAllDepositsProducts = () => {
    return api("get", "api/products/deposits", "", null);
};

export const generateActiveAndDormantDeposits = (data) => {
    return generateReport("post", "api/account/saving-report-certificate", "", data);
};

export const generateActiveAndDormantwasamwiseDeposits = (data) => {
    return generateReport("post", "api/account/saving-report-wasam-wise", "", data);
};

export const generateActiveAndDormantwasamwise = (data) => {
    return generateReport("post", "api/account/wasam-wise", "", data);
};

export const getAllWasamsByBranchId = (data) => {
    return api("get", "api/wasmas",data,null);
};

export const getAllWasamsByBranchIds = (branchIds) => {
    return api("post", "api/wasmas/by-branches", "", branchIds);
};

export const generateCDPDReport = (data) => {
  return generateReport("post", "api/account/cdpd", "", data)
}

export const generateMonthlyAllWasamReport = (data) => {
    return generateReport("post", "api/account/date-wise-dormant", "", data)
  }

export const generateCDPDWasamWiseReport = (data) => {
    return generateReport("post", "api/account/cdpd-wasamwise", "", data);
}

export const getDistrictBranches = () => {
    return api("get", "api/district-branch/list", "", null);
};

export const getDivAreaBranches = () => {
    return api("get", "api/div-branch/list",null);
}

export const existAccount = (data) => {
    return api("post", "api/account/existAccount","",data)
}

export const generateAccountDetailsReport = (data) => {
    return generateReport("post","api/account/accountReport","",data)
}

export const generateBackdateActiveAndDormantReport = (data) => {
    return generateReport("post","api/account/backdate-reports","",data)
}

export const fieldCollectionReport = (data) => {
    return generateReport("post","api/account/field-collection","",data)
}

export const SavingCertificateReport = (data) => {
    return generateReport("post","api/account/saving-certification-report","",data)
}
export const LoanCertificateReport = (data) => {
    return generateReport("post","api/account/loan-certification-report","",data)
}

export const districtBranchWiseDeposits = (data) => {
    return api("post","api/district-branch/dormant-active-summary","",data)
}

export const districtDistrictWiseDeposits = (data) => {
    return api("post","api/district/dormant-active-summary","",data)
}

export const districtDivisionalWiseDeposits = (data) => {
    return api("post","api/divisional/dormant-active-summary","",data)
}

export const branchProductWiseDeposits = (data) => {
    return api("post","api/branch/gn-wise/summary","",data)
}

export const branchWiseDeposits = (data) => {
    return api("post","api/branch-wise/summary","",data)
}

export const ShareMemberDRDistrictWise = (data) => {
    return api("post","excel/district/share-member-summary","",data)
}

export const ShareMemberDRBranchWise = (data) => {
    return api("post","excel/branch/share-member-summary","",data)
}

export const OtherDepositsBranchWise = (data) => {
    return api("post","excel/branch/other-summary","",data)
}



export const OtherDRDistrictWise = (data) => {
    return api("post","excel/district/other-summary","",data)
}

export const OtherDRBranchWise = (data) => {
    return api("post","excel/branch/other-summary","",data)
}

export const getDistrictDivisionalBranchDetails = () => {
    return api("get","api/district-divisional-branch","",null)
}

export const getAllFieldCollections=(data)=>{
    return api ("post","api/field-collection","",data);
};

export const getAllAccountList=(data)=>{
    return api("post", "api/account/account-list", "", data);
}

export const getAllClosedAccounts = (data) => {
    return api("post", "api/account/account-list/closed-accounts", "", data);
};

export const getAllInactiveAccounts = (data) => {
    return api("post", "api/account/account-list/inactive-accounts", "", data);
};

export const getAllInterestProcessList = (data) => {
    return api("post", "api/transactions/interest-process", null, data);
};

export const getOpenAccountsReport = (data) => {
    return api("post", "api/reports/open-accounts-data", "", data);
};

export const getNonPriorityCustomerAccountsReport = (data) => {
    return api("post", "api/reports/non-priority-customer-accounts", "", data);
};